module.exports = __webpack_public_path__ + "static/media/people-woman-coffee-meeting.a1a66f14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/app2soft/images/001_fe/people-woman-coffee-meeting.jpg
// module id = 763
// module chunks = 0